import { QueryParams } from "@/api";
import { SchoolProvider, SchoolType } from "@/types/models/School.interface";
import { AddressCountry } from "@/types/models/Address.interface";
import { LicenseProduct } from "@/types/models/License.interface";

export interface SchoolSource {
  provider: SchoolProvider;
  id?: number;
  unique_id?: string;
}

export interface SchoolEditableFields {
  name: boolean;
  school_type: boolean;
  nces_district_id: boolean;
  nces_school_id: boolean;
  notes: boolean;
  website: boolean;
  address: {
    address1: boolean;
    address2: boolean;
    address3: boolean;
    city: boolean;
    country: boolean;
    state: boolean;
    zip_code: boolean;
  };
  isValid?: boolean;
  district_id?: boolean;
}

export interface SchoolLicense {
  id: number;
  product: LicenseProduct;
  expiration_date: string | null;
}

export interface SchoolClassroom {
  id: number;
  pk: number;
  unique_id: string;
  name: string;
}

export interface SchoolTeacher {
  id: number;
  unique_id: string;
  user: {
    first_name: string;
    last_name: string;
  };
}

export interface SchoolStudent {
  id: number;
  unique_id: string;
  user: {
    first_name: string;
    last_name: string;
  };
}

export interface SchoolDistrict {
  unique_id: string;
  id: number;
  pk: number;
  name: string;
  is_top_level: boolean;
}

export interface SchoolAddress {
  address1?: string;
  address2?: string;
  address3?: string;
  city?: string;
  country?: AddressCountry;
  id: number;
  state?: string;
  zip_code?: string | null;
}

export interface SchoolTimezone {
  name?: string;
  alias?: string;
  utc_offset?: number;
  observes_dst?: boolean;
}

export interface School {
  _editable?: SchoolEditableFields;
  id: number;
  pk: number;
  unique_id: string;
  name: string;
  school_type: SchoolType;
  nces_district_id?: string | null;
  nces_school_id?: string | null;
  date_modified: string;
  email_domains: string[];
  customer_email_domains?: string[];
  website?: string | null;
  is_valid?: boolean | null;
  sources?: SchoolSource[];
  licenses?: SchoolLicense[];
  soonest_expiration?: number | null;
  notes?: string | null;
  classrooms?: SchoolClassroom[];
  district?: SchoolDistrict[];
  address?: SchoolAddress;
  timezone?: SchoolTimezone;
}

export interface SchoolThroughUserFilter extends QueryParams {
  include_classrooms?: boolean;
  include_district?: boolean;
  include_licenses?: boolean;
  sort?: string;
}

export type SchoolThroughUserResponse = School[];

export const schoolThroughUserFilterMock: SchoolThroughUserFilter = {
  include_classrooms: false,
  include_district: false,
  include_licenses: false,
  sort: "name,last_name",
};

export const schoolThroughUserResponseMock: SchoolThroughUserResponse = [
  {
    id: 2000287688,
    pk: 2000287688,
    unique_id: "3ffa7e5571704362a4716a7d385e5603",
    name: "ELA District High School",
    school_type: "PU",
    nces_district_id: null,
    nces_school_id: null,
    date_modified: "2024-05-07T18:20:23Z",
    email_domains: [],
    is_valid: true,
    sources: [],
    address: {
      address1: "451 Anderson Oval",
      address2: "",
      address3: "",
      city: "Jeffreyhaven",
      country: "US",
      id: 2000325115,
      state: "ND",
      zip_code: "58849",
    },
    timezone: {},
  },
];
